export enum InsuranceProvider {
  All = 'all',
  Medicare = 'Medicare',
  TexasMedicaid = 'Texas Medicaid',
  PrivatePay = 'Private Pay',
  TexasMedicaidHMO = 'Texas Medicaid HMO',
  Commercial = 'Commercial',
  CaliforniaMedicaid = 'California Medicaid',
}
